<template>
  <div class="about5">
    <div>
      龍崎文衡殿佔地廣大，除了雄偉的本殿建築之外，有偌大的廣場可供停車以及舉辦活動。廟殿兩旁綠樹成蔭，是極佳的休閒處，我們規劃了許多休憩遊樂區域，有可觀賞龍崎風景的泡茶區、可供烤肉煮火鍋的野炊區，並有自助投幣式卡拉OK供您歡唱。
    </div>
    <div>&nbsp;</div>
    <div>
      此外，還設有販賣部提供茶點零食、飲料、伴手禮等等。歡迎週末假日來這裡走走逛逛，適合一家大小悠閒渡過一個下午。
    </div>
    <div>&nbsp;</div>
    <swiper
      class="swiper"
      :key="swiperOption.slidesPerView"
      :options="swiperOption"
    >
      <swiper-slide>
        <img
          class="about5-swiper-img cursor-pointer"
          src="~@/assets/images/about-page5-img-1.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="about5-swiper-img cursor-pointer"
          src="~@/assets/images/about-page5-img-2.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="about5-swiper-img cursor-pointer"
          src="~@/assets/images/about-page5-img-3.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="about5-swiper-img cursor-pointer"
          src="~@/assets/images/about-page5-img-4.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <transition
      enter-active-class="fade-enter-active"
      leave-active-class="fade-leave-active"
    >
      <modal v-if="modalOpen" class="about5-modal" @onClose="closeModal()">
        <div slot="body">
          <swiper class="swiper" :options="modalSwiperOption">
            <swiper-slide>
              <img
                class="about5-swiper-img"
                src="~@/assets/images/about-page5-img-1.jpg"
              />
            </swiper-slide>
            <swiper-slide>
              <img
                class="about5-swiper-img"
                src="~@/assets/images/about-page5-img-2.jpg"
              />
            </swiper-slide>
            <swiper-slide>
              <img
                class="about5-swiper-img"
                src="~@/assets/images/about-page5-img-3.jpg"
              />
            </swiper-slide>
            <swiper-slide>
              <img
                class="about5-swiper-img"
                src="~@/assets/images/about-page5-img-4.jpg"
              />
            </swiper-slide>
            <div
              class="swiper-button-prev about5-modal-button"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next about5-modal-button"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Modal from 'Components/modal.vue';
import 'swiper/css/swiper.css';
export default {
  name: 'About5',
  components: {
    Swiper,
    SwiperSlide,
    Modal,
  },
  data() {
    return {
      page: this.$route.query.page,
      slidesPerView: 2,
      modalSwiperOption: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      modalOpen: false,
    };
  },
  mounted() {
    const vm = this;
    vm.slidesPerView = window.innerWidth < 768 ? 1 : 2;
    window.onresize = () => {
      vm.slidesPerView = window.innerWidth < 768 ? 1 : 2;
    };
  },
  computed: {
    swiperOption: function() {
      return {
        slidesPerView: this.slidesPerView,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      };
    },
  },
  methods: {
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.about5-swiper-img {
  width: 100%;
}
.swiper-button-prev,
.swiper-button-next {
  color: #ffffff;
}
.fade-enter-active {
  animation: show 0.5s;
}

.fade-leave-active {
  animation: hide 0.5s;
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@media (max-width: 767px) {
  .about5-modal-button {
    display: none;
  }
}
@media (min-width: 768px) {
  .about5-modal >>> .custom-modal-container {
    min-width: 590px;
    max-width: inherit;
  }
  .about5-modal >>> img {
    max-height: 90vh;
  }
}
</style>
